import Utils from "@/libs/Utils";
import React, { VoidFunctionComponent } from 'react';
import { BundleOffersProduct } from "@/models/scope/productSheet/promotionalOffers/BundleOffersProduct";

interface Props {
  product: BundleOffersProduct;
}

export const ProductItem: VoidFunctionComponent<Props> = ({ product }) => {
  if (!product) {
    return null;
  }

  const { ean13, image, crossedOutPrice, price, frontLabel, productSheetUrl } = product;

  return (
    <div className='container' key={ean13}>
      <div className='bundle-item'>
        <a href={productSheetUrl} target={'_blank'}>
          <picture>
            <source srcSet={image} />
            <img src={image} alt={frontLabel} />
          </picture>
        </a>
        <div className='data'>
          <p className='label'>{frontLabel}</p>
          <div className='prices'>
            {!!crossedOutPrice && (
              <p className='crossed-out-price'>{`${Utils.formatPriceWithoutTax(crossedOutPrice)} €`}</p>
            )}
            {!!price && (
              <p className='price'>{`${Utils.formatPriceWithoutTax(price)} €`}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};